import styled from '@emotion/styled';
import { spacing, fontSize } from '@playdapp/ui';

const WarningText = styled.p<{ marginTop?: string }>`
  margin-top: ${({ marginTop }) => marginTop || spacing.l};
  font-size: ${fontSize.p4};
  color: #ef586e;
`;

export default WarningText;
